export default __webpack_public_path__ + "static/VT323-Regular-bddd705ec7f7fc153ad8f45334233613.ttf";